// extracted by mini-css-extract-plugin
module.exports = {"detail":"high-formwork-detail_detail_104Kt","listWrap":"high-formwork-detail_listWrap_ZsBQg"};